import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import centralizeAndSimplifyPng2x from './assets/CentralizeAndSimplify@2x.png'
import centralizeAndSimplifyWebp from './assets/CentralizeAndSimplify.webp'
import centralizeAndSimplifyWebp2x from './assets/CentralizeAndSimplify@2x.webp'

const CentralizeAndSimplifyImage = () => {
  return (
    <Picture>
      <source type="image/webp" srcSet={`${centralizeAndSimplifyWebp}, ${centralizeAndSimplifyWebp2x} 2x`} />
      <Image
        src={centralizeAndSimplifyPng2x}
        alt="Illustration: Centralize and simplify"
        width="640"
        height="410"
        loading="lazy"
      />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default CentralizeAndSimplifyImage
